import { defineComponent as o, Types as f } from "bitecs";
const r = o({
  posX: f.f32,
  posY: f.f32,
  posZ: f.f32,
  rotX: f.f32,
  rotY: f.f32,
  rotZ: f.f32,
  rotW: f.f32,
  eulerX: f.f32,
  eulerY: f.f32,
  eulerZ: f.f32,
  scaleX: f.f32,
  scaleY: f.f32,
  scaleZ: f.f32
}), s = o({
  posX: f.f32,
  posY: f.f32,
  posZ: f.f32,
  rotX: f.f32,
  rotY: f.f32,
  rotZ: f.f32,
  rotW: f.f32,
  eulerX: f.f32,
  eulerY: f.f32,
  eulerZ: f.f32,
  scaleX: f.f32,
  scaleY: f.f32,
  scaleZ: f.f32
});
export {
  r as Transform,
  s as WorldTransform
};
//# sourceMappingURL=components.js.map
